import { User } from "@/models/user";
import { Dossier } from "@/models/dossier";
import { Axios } from "@/services/auth-service";
import { CompanyService } from "@/services/company-service";
import Vue from "vue";

export const CompanyUserService = new Vue({
	methods: {
		getUrl(companyId:number) {
			return `${CompanyService.url}/${companyId}/users`;
		},

		getAccountantDossiersUrl(companyId:number, userId:number) {
			return `${this.getUrl(companyId)}/${userId}/accountant-dossiers`;
		},

		async getUser(companyId:number, userId:number){
			let result = await Axios.get(`${this.getUrl(companyId)}/${userId}`);
			return new User(result.data);
		},

		async createNewUser(companyId:number, user:User, password:string):Promise<User> {
			let result = await Axios.post(`${this.getUrl(companyId)}`, {
				User: user.getJSON(),
				Password: password
			});
			return new User(result.data);
		},

		async updateUser(companyId:number, user:User):Promise<User> {
			let result = await Axios.put(`${this.getUrl(companyId)}/${user.id}`, user.getJSON());
			return new User(result.data);
		},

		async updatePassword(companyId:number, user:User, password:string):Promise<User> {
			let result = await Axios.put(`${this.getUrl(companyId)}/${user.id}/password`, {Password: password});
			return new User(result.data);
		},

		async deleteUser(companyId:number, user:User):Promise<void> {
			await Axios.delete(`${this.getUrl(companyId)}/${user.id}`);
			return;
		},

		async sendActivationLink(companyId:number, user:User):Promise<void> {
			await Axios.post(`${this.getUrl(companyId)}/${user.id}/send-activation-link`);
		},

		async getAccountantDossiers(companyId:number, userId:number):Promise<Dossier[]> {
			let result = await Axios.get(this.getAccountantDossiersUrl(companyId, userId));
			return (result.data as any[]).map(d => new Dossier(d));
		},

		async addAccountantDossier(companyId:number, userId:number, dossierId:number):Promise<Dossier> {
			let result = await Axios.post(`${this.getAccountantDossiersUrl(companyId, userId)}/${dossierId}`);
			return new Dossier(result.data);
		},

		async removeAccountantDossier(companyId:number, userId:number, dossierId:number):Promise<void> {
			await Axios.delete(`${this.getAccountantDossiersUrl(companyId, userId)}/${dossierId}`);
		}
	}
});